import React, { useEffect, useState } from "react";

import NextImage from "./NextImage";
import {
  convertDate,
  extractScores,
  getImageUrl,
  getRemainingTimeInHoursMinutes,
  renderScores,
  teamLeagueInfoUrl,
} from "../../utils/generalLiveCenter";
import { DateUtility } from "../../utils/dateUtility";
import MatchDateTime from "./MatchDateTime";
import MatchMinutes from "./MatchMinutes";
import {
  CricketScore,
  GetMatchScores,
  GetTennisMatchStatus,
  ToLowerText,
} from "../../utils/generalLiveCenter";
import { MatchOptions } from "../../utils/matchOptions";
import { useMatchSocket } from "../../hooks/useMatchSocket";

const MatchDetailHead = ({
  data,
  sport = "football",
  difference,
  referee,
  venue,
  form,
  websiteBaseUrl,
  dataPath,
  dataClient,
  socketUrl,
  channel,
  event,
  baseUrl,
}) => {
  const scores = [];
  const [match, setMatch] = useState(data);
  const matchStatus = GetTennisMatchStatus(match?.st, match?.cp, match);
  const live = MatchOptions?.basketballLiveStatuses?.includes(match?.st);
  const scoreType = [
    "1st set",
    "2nd set",
    "3rd set",
    "4th set",
    "5th set",
  ].includes(matchStatus)
    ? "cfs"
    : "finished";
  const score = match?.scores?.find((t) => ToLowerText(t?.ty) === scoreType);

  const hscore = score?.nm?.split(":")?.[0]?.trim();
  const ascore = score?.nm?.split(":")?.[1]?.trim();

  const matchScore = GetMatchScores(match?.scores, matchStatus);

  const imageUrl = getImageUrl(
    "",
    "",
    sport,
    match?.competitors?.[sport === "tennis" ? "hpid" : "htid"]
  );
  const awayImage = getImageUrl(
    "",
    "",
    sport,
    match?.competitors?.[sport === "tennis" ? "apid" : "atid"]
  );

  if (sport === "basketball" || sport === "icehockey") {
    for (let i = 1; i <= 4; i++) {
      scores.push(extractScores(match, i));
    }
  }

  const baseURL =
    process.env.REACT_APP_BASE_URL ??
    "https://ipublisher-microservices.6lgx.com";

  useMatchSocket({ socketUrl, channel, event, sport, setMatch });

  useEffect(() => {
    setMatch(data);
  }, [data]);

  // Check if sport is basketball-like (basketball, rugby, rugby-union, icehockey)
  const isBasketballLike =
    sport === "basketball" ||
    sport === "rugby" ||
    sport === "rugby-union" ||
    sport === "icehockey";

  return (
    <div className="detail_head_main">
      <div className="top_bar">
        {isBasketballLike && match?.st !== "NSY" ? (
          <span
            className={`${match?.st === "Live" ? "stats_tag red" : "stats_tag"
              }`}
          >
            {match?.st}
          </span>
        ) : null}
        <h1>
          <span className="icon_flag">
            <NextImage
              src={`${baseURL}/public/assets/images/flags/country_${match?.tournament?.football_category?.fid ||
                match?.tournament?.fid
                }.png`}
              alt="flag"
              width={22}
              height={22}
              priority={false}
            />
          </span>
          <a
            href={teamLeagueInfoUrl({
              dataClient,
              websiteBaseUrl,
              dataPath,
              category: "league",
              sport,
              name: match?.tournament?.nm,
              id: match?.tournament?.id,
            })}
          >
            <span className="name">{match?.tournament?.nm}</span>
          </a>
        </h1>
      </div>

      {isBasketballLike ? (
        <div className="b_detail_head_body">
          <div className="b_row_wrp">
            <div className="b_dtl_row">
              <div className="b_body_rgt">
                <div className="team">
                  <div className="logo_img">
                    <NextImage
                      src={imageUrl}
                      height={44}
                      width={44}
                      alt="homeLogo"
                      priority={false}
                      key={match?.competitors?.htid}
                    />
                  </div>
                  <div className="name">
                    <a
                      className={`team_logo_name ${Number(match?.ft?.split("-")?.[0]) >
                        Number(match?.ft?.split("-")?.[1])
                        ? "bold"
                        : ""
                        }`}
                      href={teamLeagueInfoUrl({
                        dataClient,
                        websiteBaseUrl,
                        dataPath,
                        category: sport === "tennis" ? "player" : "team",
                        sport,
                        name: match?.competitors?.htn,
                        id: match?.competitors?.htid,
                      })}
                    >
                      {match?.competitors?.htn}
                    </a>
                  </div>
                </div>
                <ul className="b_result_inf">
                  {match?.competitors?.htf && (
                    <li>
                      <ul className="result_list">
                        {match?.competitors?.htf.map((item, index) => (
                          <li
                            className={
                              item === "L"
                                ? "clr_red"
                                : item === "W"
                                  ? "clr_green"
                                  : ""
                            }
                            key={index}
                          >
                            {item}
                          </li>
                        ))}
                      </ul>
                    </li>
                  )}
                  {match?.st !== "NSY" ? (
                    <li>
                      <ul className="result_list">
                        {renderScores(sport, scores, matchScore, true)}
                      </ul>
                    </li>
                  ) : null}
                </ul>
                {match?.st !== "NSY" ? (
                  <div
                    className={`b_body_score ${Number(match?.ft?.split("-")?.[0]) >
                      Number(match?.ft?.split("-")?.[1])
                      ? "bold"
                      : ""
                      }`}
                  >
                    {match?.ft?.split("-")?.[0]}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="b_dtl_row">
              <div className="b_body_rgt">
                <div className="team">
                  <div className="logo_img">
                    <NextImage
                      src={awayImage}
                      height={44}
                      width={44}
                      alt="awayLogo"
                      priority={false}
                      key={match?.competitors?.atid}
                    />
                  </div>
                  <div className="name">
                    <a
                      className={`team_logo_name ${Number(match?.ft?.split("-")?.[0]) <
                        Number(match?.ft?.split("-")?.[1])
                        ? "bold"
                        : ""
                        }`}
                      href={teamLeagueInfoUrl({
                        dataClient,
                        websiteBaseUrl,
                        dataPath,
                        category: sport === "tennis" ? "player" : "team",
                        sport,
                        name: match?.competitors?.atn,
                        id: match?.competitors?.atid,
                      })}
                    >
                      {match?.competitors?.atn}
                    </a>
                  </div>
                </div>
                <ul className="b_result_inf">
                  {match?.competitors?.atf && (
                    <li>
                      <ul className="result_list">
                        {match?.competitors?.atf.map((item, index) => (
                          <li
                            className={
                              item === "L"
                                ? "clr_red"
                                : item === "W"
                                  ? "clr_green"
                                  : ""
                            }
                            key={index}
                          >
                            {item}
                          </li>
                        ))}
                      </ul>
                    </li>
                  )}
                  {match?.st !== "NSY" ? (
                    <li>
                      <ul className="result_list">
                        {renderScores(sport, scores, matchScore, false)}
                      </ul>
                    </li>
                  ) : null}
                </ul>
                {match?.st !== "NSY" ? (
                  <div
                    className={`b_body_score ${Number(match?.ft?.split("-")?.[0]) <
                      Number(match?.ft?.split("-")?.[1])
                      ? "bold"
                      : ""
                      }`}
                  >
                    {match?.ft?.split("-")?.[1]}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          {match?.st === "NSY" ? (
            <div className="remaining_time">
              {getRemainingTimeInHoursMinutes(match?.dt)}
            </div>
          ) : null}
        </div>
      ) : (
        <div className="detail_head_body">
          <div
            className={`body_top ${sport === "tennis" ? "tennis_body_top" : ""
              }`}
          >
            <div className="body_top_col">
              {sport !== "tennis" && (
                <div className="team_logo">
                  <NextImage
                    src={imageUrl}
                    height={44}
                    width={44}
                    alt="homeLogo"
                    priority={false}
                  />
                </div>
              )}

              <span className={"player_team_name"}>
                <a
                  href={teamLeagueInfoUrl({
                    dataClient,
                    websiteBaseUrl,
                    dataPath,
                    category: sport === "tennis" ? "player" : "team",
                    sport,
                    name: match?.competitors?.htn,
                    id: match?.competitors?.htid,
                  })}
                >
                  <span
                    className={`team_logo_name ${match?.win === 1 ? "bold" : ""
                      }`}
                  >
                    {match?.competitors?.htn}
                  </span>
                </a>
                {sport === "cricket" ? (
                  <span className="cr_team_score">
                    {CricketScore(match?.hts)}
                  </span>
                ) : (
                  <span className="player_scores">
                    {renderScores(sport, scores, matchScore, true)}
                  </span>
                )}
              </span>
              <ul className="result_list">
                {(sport === "football"
                  ? match?.competitors?.htf
                  : form?.[match?.competitors?.htid]
                )
                  ?.slice()
                  .reverse()
                  .map((item, index) => (
                    <li
                      className={
                        item === "L"
                          ? "clr_red"
                          : item === "W"
                            ? "clr_green"
                            : ""
                      }
                      key={index}
                    >
                      {item}
                    </li>
                  ))}
              </ul>
            </div>

            <div className="body_top_col timing">
              <span className="match_list_date_status">
                {sport === "cricket" && match?.bs !== "Finished" && (
                  <>
                    <span className="status">{match?.bs}</span>
                    <span className="time">{match?.st}</span>
                  </>
                )}
                {sport === "cricket" ? (
                  match?.st === "Finished" && (
                    <div className="status_wrp">
                      <span>{match?.com}</span>
                      <span className="status">Finished</span>
                    </div>
                  )
                ) : (
                  <>
                    {match?.st === "Delayed" && (
                      <span className="status">Dly</span>
                    )}
                    {match?.st === "Interrupted" && (
                      <span className="status">Interrupted</span>
                    )}
                    {match?.st === "Full Time" && (
                      <span className="status">FT</span>
                    )}
                    {match?.st === "Finished" &&
                      match?.mins === "To Finish" && (
                        <span className="status">To FT</span>
                      )}
                    {match?.st === "Finished AP" && match?.mins === "FAP" && (
                      <span className="status">Fi. AP</span>
                    )}
                    {match?.st === "Finished" &&
                      match?.mins !== "FAP" &&
                      match?.mins !== "FAET" && (
                        <span className="status">FT</span>
                      )}
                    {match?.st === "Finished" && match?.mins === "FAP" && (
                      <span className="status red">FAP</span>
                    )}
                    {match?.st === "Finished" && match?.mins === "FAET" && (
                      <span className="status">FAET</span>
                    )}
                    {match?.st === "Postponed" && (
                      <span className="status">PPD</span>
                    )}
                    {match?.st === "Abandoned" && (
                      <span className="status">AB</span>
                    )}
                    {match?.st === "Cancelled" && (
                      <span className="status">AB</span>
                    )}
                    {match?.st === "TF" && <span className="status">TF</span>}
                    {match?.st === "NSY" && (
                      <MatchDateTime
                        match={match}
                        sport={sport}
                        difference={difference}
                      />
                    )}
                    {sport === "football" &&
                      MatchOptions.footballLiveStatuses?.some(
                        (status) =>
                          status.toLowerCase() === match?.st?.toLowerCase()
                      ) ? (
                      <MatchMinutes match={match} cssclass={"status"} />
                    ) : null}
                  </>
                )}

                {sport === "tennis" && (
                  <>
                    {live && (
                      <span className="status">
                        {GetTennisMatchStatus(match?.st, match?.cp, match)}
                      </span>
                    )}
                  </>
                )}
              </span>

              <div className="team_score">
                {(MatchOptions.footballLiveStatuses?.some(
                  (status) =>
                    status.toLowerCase() === match?.st?.toLowerCase()
                ) ||
                  MatchOptions.basketballLiveStatuses?.some(
                    (status) =>
                      status.toLowerCase() === match?.st?.toLowerCase()
                  )) && (
                    <>
                      {sport === "tennis" ? (
                        <>
                          <span>{matchScore?.gamehome}</span> <span>-</span>{" "}
                          <span>{matchScore?.gameaway}</span>
                        </>
                      ) : (
                        sport !== "cricket" && (
                          <>
                            <span>{match?.cfs?.split("-")?.[0]}</span>{" "}
                            <span>-</span>{" "}
                            <span>{match?.cfs?.split("-")?.[1]}</span>
                          </>
                        )
                      )}
                    </>
                  )}
                {MatchOptions.footballFTStatuses?.includes(match?.st) &&
                  sport !== "cricket" &&
                  sport !== "tennis" &&
                  match?.cfs && (
                    <>
                      <span>{match?.cfs?.split("-")?.[0]}</span>
                      <span>-</span> <span>{match?.cfs?.split("-")?.[1]}</span>
                    </>
                  )}
                {(match?.st === "NSY" || match?.st === "Result Only") && <></>}
                {hscore && !live && (
                  <>
                    <span>{hscore}</span> <span>-</span> <span>{ascore}</span>
                  </>
                )}
              </div>

              {sport === "football" &&
                MatchOptions.footballLiveStatuses?.some(
                  (status) => status.toLowerCase() === match?.st?.toLowerCase()
                ) ? (
                <span>{match?.cp}</span>
              ) : null}

              {/* Penalty shootout display */}
              <div>{match?.ps ? <span>({match.ps})</span> : null}</div>

              {(sport === "basketball" || sport === "icehockey") && (
                <>
                  {(MatchOptions.footballLiveStatuses?.some(
                    (status) =>
                      status.toLowerCase() === match?.st?.toLowerCase()
                  ) ||
                    MatchOptions.basketballLiveStatuses?.some(
                      (status) =>
                        status.toLowerCase() === match?.st?.toLowerCase()
                    )) && <span className="status">{match?.cp}</span>}
                </>
              )}
            </div>

            <div className="body_top_col reverse">
              {sport !== "tennis" && (
                <div className="team_logo heart-r">
                  <NextImage
                    src={awayImage}
                    height={44}
                    width={44}
                    alt="awayLogo"
                    priority={false}
                  />
                </div>
              )}
              <span className={"player_team_name"}>
                <a
                  href={teamLeagueInfoUrl({
                    dataClient,
                    websiteBaseUrl,
                    dataPath,
                    category: sport === "tennis" ? "player" : "team",
                    sport,
                    name: match?.competitors?.atn,
                    id: match?.competitors?.atid,
                  })}
                >
                  <span
                    className={`team_logo_name ${match?.win === 2 ? "bold" : ""
                      }`}
                  >
                    {match?.competitors?.atn}
                  </span>
                </a>
                {sport === "cricket" ? (
                  <span className="cr_team_score">
                    {CricketScore(match?.ats)}
                  </span>
                ) : (
                  <span className="player_scores">
                    {renderScores(sport, scores, matchScore, false)}
                  </span>
                )}
              </span>
              <ul className="result_list">
                {(sport === "football"
                  ? match?.competitors?.atf
                  : form?.[match?.competitors?.atid]
                )
                  ?.slice()
                  .reverse()
                  .map((item, index) => (
                    <li
                      key={index}
                      className={
                        item === "L"
                          ? "clr_red"
                          : item === "W"
                            ? "clr_green"
                            : ""
                      }
                    >
                      {item}
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </div>
      )}

      <div className="detail_head_btm">
        <ul className="inf_mch">
          {match?.dt ? (
            <li>
              <i className="ico ico_calandar02"></i>
              <span className="inf_mch_txt">
                {DateUtility?.ConvertCETtoCurrentTimeZoneDate
                  ? DateUtility.ConvertCETtoCurrentTimeZoneDate(
                    match?.dt,
                    difference
                  )
                  : convertDate(match?.dt)}
              </span>
            </li>
          ) : null}
          {venue?.name ? (
            <li>
              <i className="ico ico_bridge"></i>
              <span className="inf_mch_txt">{venue?.name}</span>
            </li>
          ) : null}
          {referee ? (
            <li>
              <i className="ico ico_glyph"></i>
              <span className="inf_mch_txt">{referee}</span>
            </li>
          ) : null}
        </ul>
      </div>
    </div>
  );
};

export default MatchDetailHead;
